import type { FC } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { Text } from "@stubhub/broadway-web";
import type { Champion } from "src/http/types";
import { useAssetsUrl } from "src/shared/hooks/useAssetsUrl";

const championNamesWrapper = css({
  display: "flex",
  columnGap: "primitives.500",
});

const championName = css({
  display: "flex",
  columnGap: "primitives.200",
  alignItems: "center",
  fontWeight: "bold",
  marginBlockStart: "primitives.50",
});

const styledFlag = css({
  borderBlockStartWidth: "thin",
  borderBlockEndWidth: "thin",
  borderInlineStartWidth: "thin",
  borderInlineEndWidth: "thin",
  borderBlockStartStyle: "solid",
  borderBlockEndStyle: "solid",
  borderInlineStartStyle: "solid",
  borderInlineEndStyle: "solid",
  borderBlockStartColor: "border",
  borderBlockEndColor: "border",
  borderInlineStartColor: "border",
  borderInlineEndColor: "border",
  width: "primitives.600",
  height: "primitives.400",
  objectFit: "cover",
});

interface Props {
  /** The title of the champion section. */
  sectionTitle: Maybe<string>;
  /** An array of champion objects. */
  champions: Champion[];
}

/**
 * ChampionSection component displays a list of champions with their names and flags.
 */
export const ChampionSection: FC<Props> = ({ sectionTitle, champions }) => {
  const assetsUrl = useAssetsUrl();
  return (
    <div>
      <Text variant="label" size="medium" color="text.subtle">
        {sectionTitle}
      </Text>
      <div className={championNamesWrapper}>
        {champions.map((champion) => (
          <div key={champion.name} className={championName}>
            <img
              className={styledFlag}
              src={`${assetsUrl}/img/assets/Flags/country/${champion.countryCode?.toLowerCase()}.png`}
              alt=""
            />
            {champion.name}
          </div>
        ))}
      </div>
    </div>
  );
};
